"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVISION_CHECK_RETRIABLE_ERRORS = exports.HASH_CHECK_RETRIABLE_ERRORS = exports.HASH_CHECK_MAX_ATTEMPTS = void 0;
exports.HASH_CHECK_MAX_ATTEMPTS = 3;
exports.HASH_CHECK_RETRIABLE_ERRORS = ['other-error'];
exports.REVISION_CHECK_RETRIABLE_ERRORS = [
    'cannot-perform-check-offline',
    'other-error',
];
//# sourceMappingURL=firmware.js.map